import * as React from "react";
import {Link} from "react-router-dom";
import {conf} from "./../../../constants/config/configVars";
import meta from "./../../../metadata.json";
import logo from "./logo.png";

interface IState {
  modalOpen: boolean;
}

export class Navbar extends React.Component<{}, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      modalOpen: false
    };
  }

  public getChangelog = () => {
    const retVal: any[] = [];
    let item = [];
    const changelog = meta.changelog;
    for (const change of changelog) {
      if (change.log !== "") {
        item.push(
          <article className="message" key={change.version}>
            <div className="message-body">
              <h2 className="title is-5">{change.version}</h2>
              <p className="subtitle is-6" style={{ marginLeft: "8px" }}>
                {change.log}
              </p>
            </div>
          </article>
        );
        retVal.splice(0, 0, item);
        item = [];
      }
    }
    return retVal;
  };

  public handleModalToggle = () => {
    this.setState({modalOpen: !this.state.modalOpen});
  };

  public render() {
    return (
      <nav className="navbar has-shadow">
        <div className="navbar-brand">
          <Link className="navbar-item" to="/">
            <img src={logo} />
          </Link>
        </div>
        <div className="navbar-menu">
          <div className="navbar-start">
            <div className="navbar-item">
              Generating all the things&nbsp;&nbsp;
              <a onClick={this.handleModalToggle}>
                <span className="has-text-grey-lighter">{conf.build === "dev" ? " [ DEV V-" + meta.build + " ]" : "  [ BETA V-" + meta.build + " ]"}</span>
              </a>
            </div>
          </div>
        </div>

        <div className={this.state.modalOpen ? "modal is-active" : "modal"}>
          <div className="modal-background" onClick={this.handleModalToggle} />
          <div className="modal-card">
            <header className="modal-card-head">
              <p className="modal-card-title">Changelog</p>
              <button className="delete" aria-label="close" onClick={this.handleModalToggle} />
            </header>
            <section className="modal-card-body">{this.getChangelog()}</section>
            <footer className="modal-card-foot" style={{justifyContent: "flex-end"}}>
              <div className="buttons has-addons is-right">
                <button className="button is-success" onClick={this.handleModalToggle}>
                  Close
                </button>
              </div>
            </footer>
          </div>
        </div>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UI/Navbar/index.tsx